/* Forever Hungry — PDP (product page) interactions.
 *
 * Loaded from layout/theme.liquid ONLY on product template (defer).
 * Everything cart-related (drawer, modal, size picker, upsell) lives in fh-cart.js
 * — this file is scoped to the product page: gallery, thumbnails, variant selection,
 * sticky bar, size chart accordion, ATC routing through window.openSizePicker.
 *
 * Why external + deferred: the previous inline script in main-product.liquid ran
 * synchronously at HTML-parse time and tried to touch #drawer-subtotal etc., which
 * live in a snippet that renders AFTER <main> closes. The null-reference throw
 * killed every binding below it, including the ATC click handler. Defer + external
 * runs after DOMContentLoaded so the whole DOM (drawer + modal + picker) exists.
 */
(function () {
  'use strict';

  var pdp = document.querySelector('[data-fh-pdp]');
  if (!pdp) return;

  /* ---------- Gallery ---------- */
  var mainImg    = document.getElementById('main-img');
  var stickyImg  = document.getElementById('sticky-img');
  var thumbsRoot = document.getElementById('thumbs');

  function setMainImage(src, srcset) {
    if (mainImg) {
      mainImg.setAttribute('src', src);
      if (srcset) mainImg.setAttribute('srcset', srcset); else mainImg.removeAttribute('srcset');
    }
    if (stickyImg) stickyImg.setAttribute('src', src);
  }

  function bindThumbClicks() {
    if (!thumbsRoot) return;
    thumbsRoot.querySelectorAll('.fh-pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src    = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset') || '';
        setMainImage(src, srcset);
        thumbsRoot.querySelectorAll('.fh-pdp__thumb').forEach(function (t) {
          var isActive = t === thumb;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });
    });
  }
  bindThumbClicks();

  /* ---------- Product JSON (variant map) ---------- */
  var productJsonEl = pdp.querySelector('[data-fh-product-json]');
  var product = null;
  if (productJsonEl) {
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) { product = null; }
  }
  var hasVariants = product && product.variants && product.variants.length > 0;

  var optionIndex = {};
  if (hasVariants) (product.options || []).forEach(function (name, i) { optionIndex[name] = i; });

  // Which option index is color vs size? Best-effort: named "Color"/"Colour" is color;
  // first remaining option is size.
  var colorIdx = hasVariants
    ? (typeof optionIndex['Color'] !== 'undefined' ? optionIndex['Color']
     : typeof optionIndex['Colour'] !== 'undefined' ? optionIndex['Colour'] : -1)
    : -1;
  var sizeIdx = -1;
  if (hasVariants) {
    (product.options || []).forEach(function (_, i) {
      if (i === colorIdx) return;
      if (sizeIdx === -1) sizeIdx = i;
    });
  }

  var hiddenId  = pdp.querySelector('[data-fh-variant-id]');
  var atcBtn    = document.getElementById('atc-btn');
  var stickyAtc = document.getElementById('sticky-atc');
  var priceEl   = pdp.querySelector('[data-fh-price]');
  var atcLabel  = pdp.querySelector('[data-fh-atc-label]');
  var stockWarn = document.getElementById('stock-warn');
  var colorLabel = document.getElementById('color-label');
  var sizeLabel  = document.getElementById('size-label');

  var LOW_STOCK_THRESHOLD = 5;

  var selection = { color: null, size: null };
  if (hasVariants) {
    var initialId = hiddenId ? parseInt(hiddenId.value, 10) : 0;
    var initial = null;
    if (initialId) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === initialId) { initial = product.variants[i]; break; }
      }
    }
    if (!initial) initial = product.variants[0];
    selection.color = colorIdx >= 0 ? initial['option' + (colorIdx + 1)] : null;
    selection.size  = sizeIdx  >= 0 ? initial['option' + (sizeIdx  + 1)]  : null;
  }

  function moneyFmt(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function findVariant() {
    if (!hasVariants) return null;
    return product.variants.filter(function (v) {
      if (colorIdx >= 0 && v['option' + (colorIdx + 1)] !== selection.color) return false;
      if (sizeIdx  >= 0 && v['option' + (sizeIdx  + 1)]  !== selection.size)  return false;
      return true;
    })[0] || null;
  }

  // 4:5 aspect (matches .fh-pdp__main, .fh-card__media, .fh-feature__tile).
  // crop=center normalizes source-image aspect variation so main-image swaps
  // (thumb click, swatch click, variant change) stay visually consistent.
  function buildSrcset(src) {
    return [480, 800, 1200, 1600].map(function (w) {
      var h = Math.round(w * 1.25);
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      return src + sep + 'width=' + w + '&height=' + h + '&crop=center ' + w + 'w';
    }).join(', ');
  }

  function withCrop(src, w, h) {
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    return src + sep + 'width=' + w + '&height=' + h + '&crop=center';
  }

  // Legacy alias: default to 4:5 aspect (h = w * 1.25). Preserves existing
  // call sites that pass just a width — they were all for main-image sized
  // URLs anyway.
  function withWidth(src, w) {
    return withCrop(src, w, Math.round(w * 1.25));
  }

  function updateStockWarn(v) {
    if (!stockWarn) return;
    if (!v || !v.available) {
      stockWarn.hidden = true;
      stockWarn.textContent = '';
      return;
    }
    if (v.inventory_management && typeof v.inventory_quantity === 'number'
        && v.inventory_quantity > 0 && v.inventory_quantity <= LOW_STOCK_THRESHOLD) {
      stockWarn.hidden = false;
      stockWarn.textContent = 'Only ' + v.inventory_quantity + ' left in size ' + (selection.size || '');
    } else {
      stockWarn.hidden = true;
      stockWarn.textContent = '';
    }
  }

  // Save-badge state — the compare-at price + "Save $X" siblings that render
  // next to the main price. Refresh on every variant swap so a shopper who
  // clicks a color/size with no sale doesn't see the stale sale copy from
  // whichever variant was selected at page render time.
  var priceCompareEl = pdp.querySelector('.fh-pdp__price-compare');
  var priceSaveEl    = pdp.querySelector('.fh-pdp__price-save');
  var priceWrapEl    = pdp.querySelector('.fh-pdp__price');

  function updateSaveBadge(v) {
    var hasCompare = v && v.compare_at_price && v.compare_at_price > v.price;
    if (hasCompare) {
      var compareDollars = moneyFmt(v.compare_at_price);
      var saveDollars = moneyFmt(v.compare_at_price - v.price);
      if (priceCompareEl) {
        priceCompareEl.textContent = compareDollars;
        priceCompareEl.hidden = false;
      } else if (priceWrapEl) {
        // First-time variant swap on a product that had no sale at render.
        // Append the two spans so the visual matches the initial-sale state.
        var span = document.createElement('span');
        span.className = 'fh-pdp__price-compare';
        span.textContent = compareDollars;
        priceWrapEl.appendChild(span);
        priceCompareEl = span;
      }
      if (priceSaveEl) {
        priceSaveEl.textContent = 'Save ' + saveDollars;
        priceSaveEl.hidden = false;
      } else if (priceWrapEl) {
        var sSpan = document.createElement('span');
        sSpan.className = 'fh-pdp__price-save';
        sSpan.textContent = 'Save ' + saveDollars;
        priceWrapEl.appendChild(sSpan);
        priceSaveEl = sSpan;
      }
    } else {
      if (priceCompareEl) priceCompareEl.hidden = true;
      if (priceSaveEl)    priceSaveEl.hidden = true;
    }
  }

  function updateUiForVariant(v) {
    if (!v) {
      if (atcBtn) atcBtn.setAttribute('disabled', '');
      if (stickyAtc) stickyAtc.setAttribute('disabled', '');
      if (atcLabel) atcLabel.textContent = 'Sold out';
      updateStockWarn(null);
      updateSaveBadge(null);
      return;
    }
    if (hiddenId) hiddenId.value = v.id;
    if (priceEl) priceEl.textContent = moneyFmt(v.price);
    if (atcBtn) {
      if (v.available) atcBtn.removeAttribute('disabled'); else atcBtn.setAttribute('disabled', '');
    }
    if (stickyAtc) {
      if (v.available) stickyAtc.removeAttribute('disabled'); else stickyAtc.setAttribute('disabled', '');
    }
    if (atcLabel) atcLabel.textContent = v.available ? ('Add to bag — ' + moneyFmt(v.price)) : 'Sold out';
    updateStockWarn(v);
    updateSaveBadge(v);
    if (v.featured_image && v.featured_image.src) {
      setMainImage(withWidth(v.featured_image.src, 1200), buildSrcset(v.featured_image.src));
    }
  }

  /* ---------- Color swatch (also rebuilds thumbnails from its data-images) ---------- */
  function rebuildThumbsForImages(images) {
    if (!thumbsRoot || !images || !images.length) return;
    thumbsRoot.innerHTML = images.map(function (src, i) {
      return '<button type="button" class="fh-pdp__thumb ' + (i === 0 ? 'is-active' : '') + '" '
        + 'data-src="' + src + '" data-srcset="' + buildSrcset(src) + '" '
        + 'aria-label="View image ' + (i + 1) + '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">'
        + '<img src="' + withCrop(src, 240, 240) + '" alt="Variant view ' + (i + 1) + '" loading="eager" decoding="async">'
        + '</button>';
    }).join('');
    setMainImage(withWidth(images[0], 1200), buildSrcset(images[0]));
    bindThumbClicks();
  }

  var swatchButtons = pdp.querySelectorAll('.fh-pdp__swatch');
  swatchButtons.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var color = swatch.getAttribute('data-color');
      selection.color = color;
      swatchButtons.forEach(function (s) {
        var isActive = s === swatch;
        s.classList.toggle('is-active', isActive);
        s.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (colorLabel && color) colorLabel.textContent = color;

      // Prefer data-images (mockup pattern) if present; else use the swatch button's data-img
      var imagesAttr = swatch.getAttribute('data-images');
      if (imagesAttr) {
        var images = [];
        try { images = JSON.parse(imagesAttr); } catch (_) {}
        if (images.length) rebuildThumbsForImages(images);
      } else {
        var singleImg = swatch.getAttribute('data-img');
        if (singleImg) setMainImage(withWidth(singleImg, 1200), buildSrcset(singleImg));
      }

      if (hasVariants) updateUiForVariant(findVariant());
    });
  });

  /* ---------- Size pills ---------- */
  // Buttons render {{ val }} (raw Shopify option value, e.g. "small") and CSS
  // `text-transform: uppercase` upcases display only. Read from data-value
  // (falls back to textContent) so JS matches variant.option case exactly —
  // v19 shipped `{{ val | upcase }}` which turned btn.textContent into "SMALL"
  // and broke findVariant() ("SMALL" !== "small"), causing main-ATC to always
  // fall back to the picker.
  var sizeButtons = pdp.querySelectorAll('.fh-pdp__size');
  sizeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var size = btn.getAttribute('data-value') || btn.textContent.trim();
      selection.size = size;
      sizeButtons.forEach(function (b) {
        var isSel = b === btn;
        b.classList.toggle('is-selected', isSel);
        b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      });
      if (sizeLabel) sizeLabel.textContent = size;
      if (hasVariants) updateUiForVariant(findVariant());
      else if (stockWarn) {
        stockWarn.hidden = true;
      }
    });
  });

  /* ---------- Sticky bar (desktop: appears after title scrolls past; mobile: always on) ---------- */
  var titleEl   = pdp.querySelector('.fh-pdp__title');
  var stickyBar = document.getElementById('pdp-sticky');
  function isMobile() { return window.matchMedia('(max-width: 720px)').matches; }
  if (titleEl && stickyBar && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (isMobile()) { stickyBar.classList.add('is-visible'); return; }
        stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(titleEl);
    if (isMobile()) stickyBar.classList.add('is-visible');
  }

  /* ---------- Size guide accordion + "Size guide ↓" button ---------- */
  var sizeGuideBtn = document.getElementById('size-guide-btn');
  var sizeChartPanel = document.getElementById('size-chart-panel');
  if (sizeGuideBtn && sizeChartPanel) {
    sizeGuideBtn.addEventListener('click', function () {
      sizeChartPanel.open = true;
      // Give it a tick so the browser paints the open state before scrolling
      setTimeout(function () {
        sizeChartPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    });
  }

  /* ---------- ATC → size picker → real Shopify /cart/add.js POST ---------- */
  function currentAtcProduct() {
    // Snapshot the ATC payload at click time. If we have Shopify variant data, pass
    // the full variant list + option positions so the picker can resolve the exact
    // variant.id from the user's size pick and POST to /cart/add.js.
    var v = hasVariants ? findVariant() : null;
    return {
      title: (product && product.title) || (titleEl && titleEl.textContent.trim()) || 'Product',
      price: v ? (v.price / 100) : (priceEl && parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''))) || 0,
      img:   mainImg ? mainImg.currentSrc || mainImg.src : '',
      color: selection.color || (colorLabel && colorLabel.textContent.trim()) || '',
      size:  selection.size  || (sizeLabel  && sizeLabel.textContent.trim())  || '',
      variantId: v ? v.id : null,
      productHandle: product && product.handle,
      variants: hasVariants ? product.variants : null,
      colorOptionPosition: colorIdx >= 0 ? (colorIdx + 1) : null,
      sizeOptionPosition:  sizeIdx  >= 0 ? (sizeIdx  + 1) : null
    };
  }

  // openPicker: safety-net fallback when we can't resolve a direct variant
  // (e.g. product has variants but nothing matched color+size, or fh-cart.js
  // isn't ready yet). Rebuilds pills from the currently-available sizes.
  function openPicker() {
    var sizes;
    if (hasVariants && sizeIdx >= 0) {
      var seen = {};
      sizes = product.variants
        .filter(function (v) {
          if (colorIdx >= 0 && selection.color && v['option' + (colorIdx + 1)] !== selection.color) return false;
          return v.available;
        })
        .map(function (v) { return v['option' + (sizeIdx + 1)]; })
        .filter(function (s) { if (!s || seen[s]) return false; seen[s] = true; return true; });
    } else {
      sizes = Array.prototype.slice.call(sizeButtons)
        .filter(function (b) { return !b.disabled; })
        .map(function (b) { return b.textContent.trim(); });
    }
    var payload = currentAtcProduct();
    if (typeof window.openSizePicker === 'function') {
      window.openSizePicker(payload, null, sizes);
    } else {
      console.warn('[fh-pdp] window.openSizePicker not available yet');
    }
  }

  // Main-ATC (button below the visible size pills): the user just picked a
  // size — the picker would ask them to re-pick. Go straight to /cart/add.js
  // with the currently-selected variant. Picker only opens as safety-net.
  function mainAtc() {
    var v = hasVariants ? findVariant() : null;
    if (v && v.available && typeof window.fhAddToCart === 'function') {
      window.fhAddToCart(v.id, 1)
        .then(function () {
          return typeof window.fhRefreshDrawer === 'function'
            ? window.fhRefreshDrawer()
            : null;
        })
        .then(function () {
          if (typeof window.openFhDrawer === 'function') window.openFhDrawer();
        })
        .catch(function (err) {
          console.warn('[fh-pdp] direct /cart/add.js failed — falling back to picker', err);
          openPicker();
        });
      return;
    }
    openPicker();
  }

  // Sticky-ATC: bar at top of scroll — size pills are OFF-SCREEN when the user
  // taps it, so surface the picker so they can confirm/change size without
  // scrolling back up.
  function stickyAtcHandler() { openPicker(); }

  if (atcBtn) atcBtn.addEventListener('click', mainAtc);
  if (stickyAtc) stickyAtc.addEventListener('click', stickyAtcHandler);

  /* ---------- Preload all variant + thumbnail images ---------- */
  // Fixes the 2-3s first-click lag. Each new Image() kicks off a fetch that the
  // browser satisfies from cache on the eventual thumbnail click.
  (function preloadAll() {
    var seen = {};
    function bump(src) {
      if (!src || seen[src]) return;
      seen[src] = true;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = src;
    }
    if (hasVariants) {
      product.variants.forEach(function (v) {
        if (v.featured_image && v.featured_image.src) bump(withWidth(v.featured_image.src, 1200));
      });
    }
    (thumbsRoot ? thumbsRoot.querySelectorAll('.fh-pdp__thumb') : []).forEach(function (t) {
      var s = t.getAttribute('data-src');
      if (s) bump(s.indexOf('width=') === -1 ? withWidth(s, 1200) : s);
    });
    // Also preload swatch-alt image sets
    swatchButtons.forEach(function (s) {
      var imagesAttr = s.getAttribute('data-images');
      if (imagesAttr) {
        try { JSON.parse(imagesAttr).forEach(function (src) { bump(withWidth(src, 1200)); }); }
        catch (_) {}
      }
      var single = s.getAttribute('data-img');
      if (single) bump(withWidth(single, 1200));
    });
  })();

  /* ---------- Seed initial state ---------- */
  if (hasVariants) updateUiForVariant(findVariant());
})();
